// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { CustomEvent } from '@shared/utils/CustomEvents';
import { TerceraButtonEvents } from '@shared/utils/Enums/ButtonEnums';
import ButtonTemplate from '@front/templates/ButtonTemplate.html';
import { ControlsTypes } from '../UtilsClasses/FactoryConstants';
import { Control } from './Control';
import { ControlsUtils } from '../UtilsClasses/ControlsUtils';
import { NewContextMenuItemType } from '@shared/utils/ContextMenuUtils';
export class TerceraButton extends Control {
    constructor() {
        super(...arguments);
        this.onBtnClick = new CustomEvent();
        this.isMouseOnButton = false;
    }
    get btnInGroup() {
        return this.get('btnInGroup');
    }
    set btnInGroup(value) {
        void this.set('btnInGroup', value);
    }
    getType() {
        return ControlsTypes.TerceraButton;
    }
    oninit() {
        super.oninit();
        this.onBtnClick = new CustomEvent();
        this.on('componentOver', this.private_MouseOver);
        this.on('componentLeave', this.private_MouseLeave);
        this.on('componentClick', this.private_MouseClick);
        this.on('componentMouseDown', this.onMouseDown);
    }
    getAbsoluteRectangle() {
        return ControlsUtils.getAbsoluteRectangleForElement(this);
    }
    //
    //
    //
    onMouseDown(context) {
        super.onMouseDown(context);
        this.fire(TerceraButtonEvents.onMouseDown, context);
    }
    private_MouseClick(e) {
        if (e === null || e === void 0 ? void 0 : e.original) {
            this.lastMouseClickX = e.original.clientX;
            this.lastMouseClickY = e.original.clientY;
        }
        if (!this.get('enabled')) {
            return;
        }
        const canCheck = this.get('canCheck');
        const checked = this.get('checked');
        if (canCheck) {
            if (this.btnInGroup && checked) {
                /* empty */
            }
            else {
                void this.set('checked', !checked);
            }
        }
        this.fire(TerceraButtonEvents.onClick);
        this.onBtnClick.Raise(this, this);
    }
    Click() {
        this.private_MouseClick(this);
    }
    private_MouseOver(event) {
        if (!this.get('enabled')) {
            return;
        }
        this.isMouseOnButton = true;
        this.fire(TerceraButtonEvents.onHover, event);
    }
    private_MouseLeave(event) {
        if (!this.get('enabled')) {
            return;
        }
        this.isMouseOnButton = false;
        this.fire(TerceraButtonEvents.onLeave, event);
    }
    getContextMenuItem() {
        return {
            type: NewContextMenuItemType.Default,
            text: this.get('contextMenuItemText'),
            svgImage: this.get('SVG') ? this.get('name') : null,
            enabled: this.get('enabled'),
            canCheck: this.get('canCheck'),
            checked: this.get('checked'),
            tag: this.get('tag'),
            event: (item) => {
                this.Click();
            }
        };
    }
}
Control.extendWith(TerceraButton, {
    template: ButtonTemplate,
    data: function () {
        return {
            text: '',
            terceraButtonStyle: 'js-button-gray25',
            zIndex: null,
            // сейчас картинка только без текста и только по центру!
            image: '', // url
            imageChecked: '',
            images: null,
            SVG: false,
            checked: false,
            canCheck: false,
            tag: null,
            localizeKey: '',
            isColoringButton: false,
            coloringButtonImage: '',
            coloringButtonColor: 'rgb(0,0,0)',
            counter: 0, // counter value, also visibile indicator -> if counter>0 than it is visible
            counterStyle: 'circle-counter', // adding '-plus' to style's name for counter > 99
            isRelative: false,
            btnInGroup: false
        };
    }
});
